import { render, staticRenderFns } from "./DataTrendStatistics.vue?vue&type=template&id=1b3832cd"
import script from "./DataTrendStatistics.vue?vue&type=script&lang=js"
export * from "./DataTrendStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataTrendStatistics.vue?vue&type=style&index=0&id=1b3832cd&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports